export const isValidDate = (d: unknown): d is Date =>
  d instanceof Date && !Number.isNaN(d.getTime());

export const toSafeDate = (value: unknown): Date | null => {
  if (!value) return null;
  const d = new Date(value as string);
  return isValidDate(d) ? d : null;
};

export const formatDateOrDash = (value: unknown, formatter: (d: Date) => string): string => {
  const d = toSafeDate(value);
  return d ? formatter(d) : "-";
};
